<template>
  <b-col cols="12">
    <b-table striped hover :items="driver_docs" :fields="driver_docs_fields" stacked="sm" scrollable>
      <template #head()="data">
          <span>
            <strong>{{ data.label }}</strong>
          </span>
      </template>
      <template v-slot:cell(upload)="data">
        <b-button
          v-b-modal.modal-1
          size="sm"
          class="m"
          @click="selectDriverDoc(data.item.data)"
          v-if="(data.item.status === 'Awaiting Upload') ? true : false"
        >Upload Document</b-button>
        <b-button
          v-b-modal.modal-1
          size="sm"
          class="m"
          @click="selectDriverDoc(data.item.data)"
          v-else
        >View Document</b-button>
      </template>
    </b-table>

    <b-modal
      ref="docsModal"
      id="modal-1"
      :title="selectedDriverDoc.title"
      :no-close-on-backdrop="true"
      scrollable
      @cancel="onCancel"
      @close="onCancel"
    >
      <b-row>
        <b-col cols="6" v-if="(typeof saveDoc.status !== 'undefined') ? true : false ">
          <b-form-group label="Status">{{ status(saveDoc.status) }}</b-form-group>
        </b-col>
        <b-col cols="6" v-if="(typeof saveDoc.status !== 'undefined') ? true : false ">
          <b-form-group label="Update Date">{{ formatDate(saveDoc.uploadTs) }}</b-form-group>
        </b-col>
        <b-col
          :cols="(item.type == 'upload') ? 6 : 12"
          v-for="item of selectedDriverDoc.form"
          v-bind:key="item._id"
        >
          <div v-if="item.type == 'upload'">
            <div v-if="(typeof saveDoc.status === 'undefined') ? true : false">
              <b-form-group
                :label="item.title"
                :invalid-feedback="errorDoc[item.key]"
                :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
                :description="item.description"
              >
                <fileUploadTemplate
                  :selectCallback="fileSelectCallback"
                  :fileKey="item.key"
                  template="document"
                  reset
                />
              </b-form-group>
            </div>
            <div v-else>
               <b-form-group label="Preview"
                             :invalid-feedback="errorDoc[item.key]"
                             :state="(typeof errorDoc[item.key] === 'undefined') ? null : false">
                <fileUploadTemplate
                  :selectCallback="fileSelectCallback"
                  :fileKey="item.key"
                  :preview="saveDoc[`${item.key}_url`]"
                  :previewType="(typeof saveDoc[`${item.key}`] !== 'undefined' && saveDoc[`${item.key}`] !== null) ? saveDoc[`${item.key}`].mime : undefined"
                  template="document"
                  :isEditable="editable"
                  :removeUploadCallback="removeUpload"
                />
              </b-form-group>
            </div>
          </div>
          <div v-if="item.type == 'text'">
            <b-form-group
              :label="item.title"
              :invalid-feedback="errorDoc[item.key]"
              :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
              :description="item.description"
            >
              <b-form-input
                v-model="saveDoc[item.key]"
                trim
                :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
                :disabled="!editable && (typeof saveDoc.status !== 'undefined')"
              ></b-form-input>
            </b-form-group>
          </div>
          <div v-if="item.type == 'date'">
            <b-form-group
              :label="item.title"
              :invalid-feedback="errorDoc[item.key]"
              :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
              :description="item.description"
            >
              <b-form-input
                v-model="saveDoc[item.key]"
                trim
                placeholder="DD-MM-YYYY"
                v-mask="'##/##/####'"
                :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
                :disabled="!editable && (typeof saveDoc.status !== 'undefined') || selectedDriverDoc.key === 'covid-cleaning'"
              ></b-form-input>
            </b-form-group>
          </div>
          <div v-if="item.type == 'tick'">
            <b-form-group
              :label="item.title"
              :invalid-feedback="errorDoc[item.key]"
              :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
            >
              <b-form-checkbox
                v-model="saveDoc[item.key]"
                value="true"
                unchecked-value="false"
                :disabled="!editable && (typeof saveDoc.status !== 'undefined')"
                :style="{'font-weight':'normal'}"
              >{{ item.description }}</b-form-checkbox>
            </b-form-group>
          </div>
          <div v-if="item.type == 'select'">
            <b-form-group
              :label="item.title"
              :invalid-feedback="errorDoc[item.key]"
              :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
              :description="item.description"
            >
              <v-select
                placeholder="Select"
                :value="getSelected(saveDoc[item.key], item.options)"
                @input="(value) => { setSelected(item.key, value) }"
                :options="item.options"
                :disabled="!editable && (typeof saveDoc.status !== 'undefined')"
                :state="(typeof errorDoc[item.key] === 'undefined') ? null : false"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="secondary" @click="cancel()">Close</b-button>
        <b-button
          size="sm"
          variant="primary"
          disabled
          v-if="savingDoc === true"
        ><b-spinner small label="Spinning"></b-spinner> Saving...</b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="saveDocButton()"
          v-else-if="(typeof saveDoc.status === 'undefined') ? true : false "
        >Save</b-button>
        <b-button size="sm" variant="success" @click="onEditClick" v-if="!editable && isEditAllow">Edit</b-button>
        <b-button  size="sm" @click="updateDocument" v-if="(editable && isEditAllow )">Save</b-button> 
        <b-button size="sm" variant="success" @click="changeDocButton()" v-else-if="(typeof saveDoc.status !== 'undefined' && !isEditAllow) ? true : false">Change</b-button> 
      </template>
    </b-modal>
  </b-col>
</template>

<script>
import fileUploadTemplate from "@/components/file-upload-template.vue";
import moment from "moment";

export default {
  name: "documents",
  components: {
    fileUploadTemplate
  },
  computed: {},
  props: {
    docType: String,
    vehicleId: String,
    docList:Object,
    docErrors:Object,
    saveDocCallback:Function,
    updateCallback:Function,
  },
  data() {
    return {
      savingDoc: false,
      files: [],
      saveDoc: {},
      errorDoc: {},
      isEditAllow:false,
      editable:false,
      selectedDriverDoc: {},
      currentRoute: null,
      driver_docs_fields: [
        {
          key: "document_name",
          label: "Document Name"
        },
        {
          key: "upload_date",
          label: "Date Uploaded"
        },
        {
          key: "expires",
          label: "Expires"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "upload",
          label: "Action"
        }
      ],

      driver_docs: []
    };
  },
  watch: {
    $route() {
      this.getCurrentRoute();
    },
    docList(){
     this.getDocuments();
    },
    docErrors(value){
      if(value != undefined){
         this.errorDoc=value;
      }
      if(value === null){
        this.errorDoc={};
        this.$refs["docsModal"].hide();
      }
    }
  },
  created() {
    
  },
  methods: {
    onEditClick(){
      this.editable=true;
    },
    updateDocument(){
      this.editable=false;
      if(this.selectedDriverDoc.key === 'covid-cleaning') {
          this.saveDoc.expiryDate = moment().add(1,'month').format('DD/MM/YYYY');
      }
      this.$emit("updateCallback", {
      key: this.selectedDriverDoc.key,
      data: this.saveDoc
      });
      if(this.saveDoc.status==="awaiting_approval"){
            this.isEditAllow=true;
      }else{
            this.isEditAllow=false;
      }
    },
    setSelected(key, value, options) {
      this.saveDoc[key] = value.value;
    },
    getSelected(selected, options) {
      for(let option of options) {
        if(option.value == selected) {
          return option.label;
        }
      }
    },
    formatDate(dateString) {
      return moment(dateString).format("DD/MM/YYYY");
    },
    status(status) {
      let statusText = "Awaiting Upload";
      switch (status) {
        case "awaiting_approval":
          statusText = "Awaiting Approval";
          break;
        case "approved":
          statusText = "Approved";
          break;
        case "decline":
          statusText = "Decline";
          break;
      }
      return statusText;
    },
    async getDocuments() {
      if (typeof this.docType !== "undefined") {
        this.$refs["docsModal"].hide();
        let newDocuments = [];

        for (let item of this.docList.documents) {
          newDocuments.push({
            document_name: item.title,
            upload_date:
              typeof item.data.uploadTs !== "undefined"
                ? this.formatDate(item.data.uploadTs)
                : "-",
            expires:
              typeof item.data.expireDate !== "undefined"
               ? this.formatDate(item.data.expireDate) 
               : "-",
            status: this.status(item.data.status),
            upload: typeof item.data.status === "undefined" ? true : false,
            data: item
          });
        }
        this.driver_docs = newDocuments;
      }
    },
    async saveDocButton() {
      try {
        this.savingDoc = true;
        if(this.selectedDriverDoc.key === 'covid-cleaning') {
          this.saveDoc.expireDate = moment().add(1,'month').format('DD/MM/YYYY');
        }
        this.$emit("saveDocCallback",{
          key:this.selectedDriverDoc.key,
          data:this.saveDoc
        });
        this.savingDoc = false;
        await this.getDocuments();
        this.$store.dispatch("authUser/getAlerts");
      } catch (e) {
        this.savingDoc = false;
        if (e.response) {
          if (
            typeof e.response.data.error !== "undefined" &&
            typeof e.response.data.error.collection !== "undefined"
          ) {
            this.errorDoc = e.response.data.error.collection;
          }
        } else {
          console.error(e);
        }
      }
    },
    url(urlPath) {
      this.$router.push({ path: urlPath });
    },
     onCancel(){
      this.editable=false;
     // this.$refs["docsModal"].hide();
    },
    getCurrentRoute() {
      this.currentRoute = this.$router.currentRoute.fullPath;
    },
    selectDriverDoc(data) {
      this.saveDoc = {};
      this.errorDoc = {};
      this.selectedDriverDoc = Object.assign({},data);
      this.saveDoc = this.selectedDriverDoc.data;
      if (typeof this.saveDoc.expireDate !== "undefined") {
        this.saveDoc.expiryDate = moment(this.saveDoc.expireDate).format("DD/MM/YYYY");
      }
      if(this.saveDoc.status==="awaiting_approval"){
            this.isEditAllow=true;
      }else{
            this.isEditAllow=false;
      }
    },
    changeDocButton() {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to replace "${this.selectedDriverDoc.title}" with a new version?`,
          {
            title: "Please Confirm update",
            size: "sm",
            buttonSize: "sm",
            okVariant: "info",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(async value => {
          if (value) {
            switch (this.docType) {
              case "vehicle":
                try {
                  this.saveDoc = {};
                  // await shebahApi.api.vehicles.deleteVehicleDocuments(
                  //   this.vehicleId,
                  //   this.selectedDriverDoc.key
                  // );
                } catch (e) {
                  throw e;
                }
                break;
              case "driver":
                try {
                  this.saveDoc = {};
                  // await shebahApi.api.documents.deleteDocuments(
                  //   this.selectedDriverDoc.key
                  // );
                } catch (e) {
                  throw e;
                }
                break;
            }
            this.selectedDriverDoc.data = {};
            this.selectDriverDoc(this.selectedDriverDoc);
            this.$refs["docsModal"].hide();
            this.$refs["docsModal"].show();
            // this.getDocuments();
            // await this.$store.dispatch("authUser/getAlerts");

            // let user = await shebahApi.api.users.get();
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    fileSelectCallback(fileId, file) {
      this.saveDoc[fileId] = file[0];
    },
    removeUpload(fileId){
      this.saveDoc[fileId]='';
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
